import ComponentLoader from "@ch/components/Loaders/ComponentLoader";

import { useParams } from "react-router-dom";
import ProjectDetails from "@ch/pages/SubscriptionsPage/tabs/MyPlan/components/ProjectDetails.tsx";
import ProgramDetails from "@ch/pages/SubscriptionsPage/tabs/MyPlan/components/ProgramDetails.tsx";
import useGetProgramById from "@ch/pages/SubscriptionsPage/hooks/useGetProgramById.ts";

const MyPlan = ({
  planId,
  hasExpired,
}: {
  planId?: string;
  hasExpired?: boolean | undefined;
}) => {
  const { programId } = useParams();

  const { program, loading } = useGetProgramById(programId);

  const isProject = program?.type === "PROJECT";

  return (
    <section className="h-full">
      {loading ? (
        <ComponentLoader />
      ) : isProject ? (
        <ProjectDetails program={program} />
      ) : (
        <ProgramDetails
          hasExpired={hasExpired}
          planId={planId}
          program={program}
        />
      )}
    </section>
  );
};

export default MyPlan;
